import type {
  AssignmentAgentOption,
  AssignmentChangeSet,
  DirectDownline,
  MemberAssignment,
  MemberDetail,
} from './types';

export const memberFixtures: readonly MemberDetail[] = [
  {
    id: '00000000-0000-4000-8000-000000000501',
    partnerId: '00000000-0000-4000-8000-000000000101',
    partnerUserId: 'player-1',
    memberType: 'NORMAL',
    status: 'ACTIVE',
    username: 'member.alpha',
    activeReferralCodes: ['REF_01HJKMNPQRSTVWXY'],
    currentAssignment: {
      agent: {
        id: '00000000-0000-4000-8000-000000000401',
        code: 'AG-A',
        name: 'Agent Alpha',
      },
      upline: {
        memberId: '00000000-0000-4000-8000-000000000599',
        username: 'member.upline',
      },
      assignmentType: 'NORMAL',
      effectiveFrom: '2026-07-01T00:00:00+07:00',
    },
    defaultWallet: {
      currencyCode: 'THB',
      status: 'ACTIVE',
      availableBalance: '1200.50',
      reservedBalance: '30.00',
    },
    directDownlineCount: 1,
    isAgentDefaultUpline: false,
    registeredAt: '2026-07-01T10:00:00+07:00',
    createdAt: '2026-07-01T10:00:00+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
    updatedAt: '2026-07-22T10:00:00+07:00',
    updatedBy: '00000000-0000-4000-8000-000000000001',
  },
  {
    id: '00000000-0000-4000-8000-000000000502',
    partnerId: '00000000-0000-4000-8000-000000000101',
    partnerUserId: 'player-2',
    memberType: 'NORMAL',
    status: 'ACTIVE',
    username: 'member.beta',
    activeReferralCodes: ['REF_02HJKMNPQRSTVWXY'],
    currentAssignment: {
      agent: {
        id: '00000000-0000-4000-8000-000000000402',
        code: 'AG-B',
        name: 'Agent Beta',
      },
      upline: {
        memberId: '00000000-0000-4000-8000-000000000501',
        username: 'member.alpha',
      },
      assignmentType: 'NORMAL',
      effectiveFrom: '2026-07-02T00:00:00+07:00',
    },
    defaultWallet: {
      currencyCode: 'USD',
      status: 'ACTIVE',
      availableBalance: '42.25',
      reservedBalance: '5.00',
    },
    directDownlineCount: 0,
    isAgentDefaultUpline: false,
    registeredAt: '2026-07-02T10:00:00+07:00',
    createdAt: '2026-07-02T10:00:00+07:00',
    createdBy: '00000000-0000-4000-8000-000000000001',
    updatedAt: '2026-07-22T11:00:00+07:00',
    updatedBy: '00000000-0000-4000-8000-000000000001',
  },
] as const;

export const directDownlineFixtures: Readonly<Record<string, readonly DirectDownline[]>> = {
  '00000000-0000-4000-8000-000000000501': [
    {
      id: '00000000-0000-4000-8000-000000000502',
      partnerId: '00000000-0000-4000-8000-000000000101',
      partnerUserId: 'player-2',
      status: 'ACTIVE',
      username: 'member.beta',
      agent: {
        id: '00000000-0000-4000-8000-000000000402',
        code: 'AG-B',
        name: 'Agent Beta',
      },
      registeredAt: '2026-07-02T10:00:00+07:00',
      createdAt: '2026-07-02T10:00:00+07:00',
      updatedAt: '2026-07-22T11:00:00+07:00',
    },
  ],
};

export const assignmentFixtures: Readonly<Record<string, readonly MemberAssignment[]>> = {
  '00000000-0000-4000-8000-000000000501': [
    {
      id: '00000000-0000-4000-8000-000000000701',
      partnerId: '00000000-0000-4000-8000-000000000101',
      memberId: '00000000-0000-4000-8000-000000000501',
      agent: {
        id: '00000000-0000-4000-8000-000000000401',
        code: 'AG-A',
        name: 'Agent Alpha',
      },
      upline: {
        memberId: '00000000-0000-4000-8000-000000000599',
        username: 'member.upline',
      },
      assignmentType: 'NORMAL',
      effectiveFrom: '2026-07-01T00:00:00+07:00',
      effectiveTo: null,
      phase: 'CURRENT',
      reason: 'Initial assignment',
      changeSetId: null,
      createdAt: '2026-07-01T00:00:00+07:00',
      createdBy: '00000000-0000-4000-8000-000000000001',
    },
  ],
};

export const mockAssignmentAgents: readonly AssignmentAgentOption[] = [
  { id: '00000000-0000-4000-8000-000000000401', code: 'AG-A' },
  { id: '00000000-0000-4000-8000-000000000402', code: 'AG-B' },
] as const;

export const assignmentChangeSetFixture: AssignmentChangeSet = {
  id: '00000000-0000-4000-8000-000000000801',
  partnerId: '00000000-0000-4000-8000-000000000101',
  mode: 'SCHEDULED',
  status: 'SCHEDULED',
  effectiveAt: '2026-08-01T00:00:00+07:00',
  reason: 'Move future traffic',
  previewHash: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA',
  changes: [
    {
      id: '00000000-0000-4000-8000-000000000802',
      memberId: '00000000-0000-4000-8000-000000000501',
      before: {
        agentId: '00000000-0000-4000-8000-000000000401',
        uplineMemberId: '00000000-0000-4000-8000-000000000599',
      },
      after: {
        agentId: '00000000-0000-4000-8000-000000000402',
        uplineMemberId: '00000000-0000-4000-8000-000000000502',
      },
      predecessorAssignmentId: '00000000-0000-4000-8000-000000000701',
      successorAssignmentId: '00000000-0000-4000-8000-000000000702',
    },
  ],
  createdAt: '2026-07-23T10:00:00+07:00',
  createdBy: '00000000-0000-4000-8000-000000000001',
  cancelledAt: null,
  cancelledBy: null,
  cancellationReason: null,
};
